import clsx from 'clsx'
import { NavLink } from 'react-router-dom'

import classes from './styles.module.scss'
import type { MenuItemProps } from './types'

export function MenuItem({
  id,
  irPara,
  icone,
  iconeDireita,
  label,
}: MenuItemProps): JSX.Element {
  return (
    <NavLink
      to={irPara}
      end
      className={({ isActive }) =>
        clsx(classes.root, {
          [classes.menuAtivo]: isActive,
        })
      }
      data-testid={`menu-item-config-${id}`}
    >
      <div className={classes.menuItemText}>
        {icone && (
          <i className={icone} data-testid={`menu-item-config-icone-${id}`} />
        )}
        <h4
          className="titulo titulo_pequeno"
          data-testid={`menu-item-config-label-${id}`}
        >
          {label}
        </h4>
      </div>
      {iconeDireita && (
        <i
          className={iconeDireita}
          data-testid={`menu-item-config-icone-${id}`}
        />
      )}
    </NavLink>
  )
}
